import axios from 'axios';
import {
  CUSTOMER_CONFIGURATION_BASE_URL,
  CUSTOMER_CONFIGURATION_CREATE,
  CUSTOMER_CONFIGURATION_DELETE,
  CUSTOMER_CONFIGURATION_UPDATE
} from '../../constants/api';
import { attachUnauthorizedInterceptor } from '../client';

export const customerConfigClient = axios.create({
  baseURL: CUSTOMER_CONFIGURATION_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true
});

attachUnauthorizedInterceptor(customerConfigClient);

export const fetchCustomerConfiguration = (body = {}, config = {}) => customerConfigClient.post('', body, config);

export const createCustomerConfiguration = (body = {}) =>
  customerConfigClient.post(CUSTOMER_CONFIGURATION_CREATE, body);

export const deleteCustomerConfiguration = (body = {}) =>
  customerConfigClient.post(CUSTOMER_CONFIGURATION_DELETE, body);

export const updateCustomerConfiguration = (body = {}) =>
  customerConfigClient.post(CUSTOMER_CONFIGURATION_UPDATE, body);
